var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16667 17.3571H1.66667V21.8571H5.16667V17.3571ZM0.666667 15.2143C0.298477 15.2143 0 15.598 0 16.0714V23.1429C0 23.6162 0.298477 24 0.666667 24H6.16667C6.53486 24 6.83333 23.6162 6.83333 23.1429V16.0714C6.83333 15.598 6.53486 15.2143 6.16667 15.2143H0.666667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 17.3571H10.25V21.8571H13.75V17.3571ZM9.25 15.2143C8.88181 15.2143 8.58333 15.598 8.58333 16.0714V23.1429C8.58333 23.6162 8.88181 24 9.25 24H14.75C15.1182 24 15.4167 23.6162 15.4167 23.1429V16.0714C15.4167 15.598 15.1182 15.2143 14.75 15.2143H9.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 2.14286H10.25V6.64286H13.75V2.14286ZM9.25 0C8.88181 0 8.58333 0.383756 8.58333 0.857143V7.92857C8.58333 8.40196 8.88181 8.78571 9.25 8.78571H14.75C15.1182 8.78571 15.4167 8.40196 15.4167 7.92857V0.857143C15.4167 0.383756 15.1182 0 14.75 0H9.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 10.9286V8.78571H12.8333V10.9286H20.75C21.1182 10.9286 21.4167 11.3123 21.4167 11.7857V15.2143H19.75V13.0714H12.8333V15.2143H11.1667V13.0714H4.25V15.2143H2.58333V11.7857C2.58333 11.3123 2.88181 10.9286 3.25 10.9286H11.1667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3333 17.3571H18.8333V21.8571H22.3333V17.3571ZM17.8333 15.2143C17.4651 15.2143 17.1667 15.598 17.1667 16.0714V23.1429C17.1667 23.6162 17.4651 24 17.8333 24H23.3333C23.7015 24 24 23.6162 24 23.1429V16.0714C24 15.598 23.7015 15.2143 23.3333 15.2143H17.8333Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 2.14286H13.75V6.64286H10.25V2.14286Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 17.3571H13.75V21.8571H10.25V17.3571Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 17.3571H22.3333V21.8571H18.8333V17.3571Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 17.3571H5.16667V21.8571H1.66667V17.3571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.356814836f2aec3814b818d057ff6b07.svg";
export { ForwardRef as ReactComponent };